import { Info } from 'lucide-react';
import { Button } from '../ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../ui/tooltip';

/** Small info icon with a hover/focus tooltip. The icon's `aria-label` carries the text for SR/touch. */
export function InfoDot({ text }: { text: string }) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger
          render={
            <Button type="button" variant="ghost" size="icon-xs" aria-label={text} className="text-muted-foreground">
              <Info className="size-3.5" />
            </Button>
          }
        />
        <TooltipContent>{text}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
